import { useMediaQuery, useTheme } from '@mui/material';

export const useIsSmallDevice = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
};
